<template>
  <v-app id="app" v-if="$route.name === 'clean-layout'"
         standalone
         :class="className"
         light >
    <print-layout
            :logo="'/static/theme/header-logo.png'"
            :QRlogo="'/static/theme/launcher-icon-4x.png'"/>
  </v-app>
  <v-app id="app" ref="app" v-else
         standalone
         :class="className"
         light>
    <notification-tray v-if="canGetAllUserInfo"/>
    <idonia-dialog/>
    <idonia-feedback/>
    <transfer-media-container :active="isAuthenticated"/>

    <idonia-header
        class="headers"
        ref="header"
        :whitelabel="$whitelabel.url"
        :logo="'/static/theme/header-logo.png'"
        :small-logo="'/static/theme/header-logo.png'"
        :title="$route.meta.title ? $tf($route.meta.title) : 'Idonia'"
        :search-enabled="$store.state.config.globalSearch && $store.getters['session/hasIdoniaScope'](AllFilesFullAccessIdoniaScope)"
        @menu="drawer = true"
        @back="goUp"
        @openActionsTrayDrawer="actionsTrayDrawer = true"
        :mode="headerMode"
        :navigation="navigation"
        :marketing-navigation="marketingNavigation"
        :mini="!isAuthenticated || !$route.meta.leftDrawerEnabled"
        v-if="!$store.getters['viewport/embed'] && !iosFullscreen"
    >
      <template slot="breadcrumbs">
        <idonia-breadcrumbs></idonia-breadcrumbs>
      </template>
      <template slot="local-actions">
        <actions-tray></actions-tray>
      </template>
      <template slot="platform-actions">
        <platform-actions></platform-actions>
      </template>
    </idonia-header>

    <idonia-embed-header
        class="headers"
        v-else-if="!iosFullscreen"
    >
      <template slot="breadcrumbs">
        <idonia-breadcrumbs></idonia-breadcrumbs>
      </template>
      <template slot="local-actions">
        <actions-tray></actions-tray>
      </template>
    </idonia-embed-header>

    <idonia-drawer
        v-if="isAuthenticated &&
         $route.meta.leftDrawerEnabled &&
          !$store.getters['viewport/embed'] &&
           $store.getters['session/hasIdoniaScope'](AllFilesFullAccessIdoniaScope) &&
           !iosFullscreen"
        :nav.sync="drawer"
        :whitelabel="$whitelabel.url"
        logo="/static/theme/header-logo.png"
    >
      <template slot="platform-actions">
        <platform-actions></platform-actions>
      </template>
    </idonia-drawer>

    <v-content class="pb-0">
      <v-container fluid fill-height class="pa-0">
        <router-view id="router-view"/>
      </v-container>
    </v-content>

    <idonia-right-drawer
        v-if="isAuthenticated && $route.meta.rightDrawerEnabled && !$store.getters['viewport/embed']"
        :show="$store.state.nav.drawerRight"
    ></idonia-right-drawer>

    <ActionsTrayDrawer v-if="showActionTrayDrawerMenu" :drawer.sync="actionsTrayDrawer" />

    <actions-fab class="hidden-md-and-up"/>

    <idonia-footer :hidePolicy="hidePolicy" :hideTerms="hideTerms" v-if="!$store.getters['viewport/embed']&&!hideFooterOnViewer"/>
    <idonia-embed-footer :hidePolicy="hidePolicy" :hideTerms="hideTerms" :hideFooter="hideFooter || hideFooterOnViewer" v-else/>
    <span class="none" style="width: 0;height: 0; position: absolute;top: 0; margin-top: -100px"></span>
    <idonia-tour v-model="tourActive" :steps="tourSteps" v-if="!$store.getters['viewport/embed']"
                 @complete="complete"/>
  </v-app>
</template>

<script>
  import IdoniaHeader from './components/header/IdoniaHeader.vue'
  import IdoniaEmbedHeader from './components/header/IdoniaEmbedHeader.vue'
  import IdoniaBreadcrumbs from './components/header/Breadcrumbs.vue'
  import PlatformActions from './components/header/PlatformActions.vue'
  import IdoniaFooter from './components/footer/IdoniaFooter.vue'
  import IdoniaEmbedFooter from './components/footer/IdoniaEmbedFooter.vue'
  import ActionsFAB from './components/actions-tray/ActionsFAB.vue'
  import ActionsTray from './components/actions-tray/ActionsTray.vue'
  import IdoniaDrawer from './components/drawer/Drawer.vue'
  import PrintLayout from './components/common/CleanLayout.vue'
  import Favico from 'favico.js'
  import $uploadState from '~/plugins/uploader/upload-state'
  import $downloadState from '~/plugins/uploader/download-state'
  import FILE_STATES from '~/plugins/uploader/file-states.js'
  import MainBus from '~/bus.js'
  import useLanguageTree from '~/commons/language'
  import ActionsTrayDrawer from '~/components/actions-tray/ActionsTrayDrawer.vue'
  import ActionsTrayDrawerMixin from '~/components/actions-tray/ActionsTray.js'
  import HeightFix from '~/mixins/HeightFix'
  import { AllFilesFullAccessIdoniaScope, IdoniaFullUserInfoScope } from '~/commons/scopes'
  const {getObjectWithLangFallback, supportedLanguages, languagesRoot} = useLanguageTree()
  const NotificationTray = () => import('~/components/notifications/NotificationTray.vue')
  const IdoniaTour = () => import('~/components/common/tour/IdoniaTour.vue')
  const IdoniaRightDrawer = () => import('./components/drawer/RightDrawer.vue')
  const IdoniaDialog = () => import('./components/common/dialog/IdoniaDialog.vue')
  const IdoniaFeedback = () => import('./components/common/IdoniaFeedback.vue')

  export default {
    name: 'app',
    mixins: [ActionsTrayDrawerMixin, HeightFix],
    components: {
      ActionsTrayDrawer,
      PrintLayout,
      IdoniaDrawer,
      IdoniaHeader,
      IdoniaEmbedHeader,
      IdoniaFooter,
      IdoniaEmbedFooter,
      ActionsTray,
      IdoniaBreadcrumbs,
      IdoniaRightDrawer,
      PlatformActions,
      NotificationTray,
      IdoniaDialog,
      IdoniaFeedback,
      IdoniaTour,
      'actions-fab': ActionsFAB
    },
    data () {
      return {
        AllFilesFullAccessIdoniaScope,
        IdoniaFullUserInfoScope,
        actionsTrayDrawer: false,
        drawer: false,
        tourActive: false,
        favicon: new Favico({
          animation: 'slide',
          position: 'up'
        }),
        sul: '',
        expiringSession: false
      }
    },
    metaInfo () {
      if (this.$route.meta.title) {
        return {
          title: this.$tf(this.$route.meta.title)
        }
      } else {
        return {
          title: 'Idonia'
        }
      }
    },
    computed: {
      canGetAllUserInfo () {
        return !this.$store.getters['session/isScoped'] || this.$store.getters['session/hasIdoniaScope'](IdoniaFullUserInfoScope)
      },
      tourSteps () {
        return this.getFallbackedTourSteps(this.$store.state.session.locale) || null
      },
      tours () {
        return this.$route.meta.tours || []
      },
      smallViewport () {
        return this.$vuetify.breakpoint.smAndDown
      },
      isAuthenticated: function () {
        return this.$store.getters['session/isAuthenticated']
      },
      isPublicFile () {
        return this.$route.name && this.$route.name.startsWith('public-file')
      },
      fullView: function () {
        return this.$store.state.nav.fullView
      },
      adminPanel: function () {
        return this.$store.state.nav.adminPanel
      },
      newNotifications: function () {
        return this.$store.getters['notifications/newNotifications']
      },
      className () {
        const classes = [`viewport-${this.$store.state.viewport.scale.name}`, `os-${this.$machine.os}`, `lang-${this.$i18n.locale}`, `lang-parent-${supportedLanguages.get(this.$i18n.locale)}`]

        if (this.fullView || (!this.isAuthenticated && this.$route.name && !this.$route.name.startsWith('public-file'))) {
          classes.push('full-view')
        }

        if (this.drawer && this.$vuetify.breakpoint.smAndDown) {
          classes.push('stuck')
        }

        classes.push(this.$machine.isDesktop ? 'desktop' : 'mobile')
        classes.push(this.$route.name)

        return classes.join(' ')
      },
      headerMode () {
        if (this.$store.getters['session/isAuthenticated']) {
          if (typeof this.$store.state.nav.navCurrent !== 'undefined' && Object.keys(this.$store.state.nav.navCurrent).length > 0) {
            return 'back'
          }
          return 'menu'
        }
        return 'none'
      },
      navigation () {
        let nav = []
        if (typeof this.$store.state.nav.navRoot !== 'undefined' && Object.keys(this.$store.state.nav.navRoot).length > 0) {
          nav = nav.concat([this.$store.state.nav.navRoot])
        }
        if (typeof this.$store.state.nav.navPath !== 'undefined') {
          nav = nav.concat(this.$store.state.nav.navPath)
        }
        if (typeof this.$store.state.nav.navCurrent !== 'undefined' && Object.keys(this.$store.state.nav.navCurrent).length > 0) {
          nav = nav.concat([this.$store.state.nav.navCurrent])
        }
        return nav
      },
      cookiePermission () {
        return this.$store.state.session.cookiePermission || false
      },
      lastCookiesPermissionVersion () {
        return this.$store.state.session.lastCookiesPermissionVersion
      },
      marketingNavigation () {
        let locale = this.$store.state.session.locale
        if (this.$route.path.startsWith('/access') || this.$route.path.startsWith('/info')) {
          let marketing = this.getObjectWithLangFallback(locale, this.$marketing, (locale) => locale.toLowerCase())
          if (marketing && marketing.info) {
            return marketing.info
          }
        }
        return []
      },
      hidePolicy: function () {
        return this.$store.getters['nav/hidePolicy']
      },
      hideTerms: function () {
        return this.$store.getters['nav/hideTerms']
      },
      hideFooter: function () {
        return this.$store.getters['nav/hideFooter']
      },
      hideFooterOnViewer: function () {
        return this.$store.getters['nav/hideFooterOnViewer']
      },
      iosFullscreen: function () {
        return this.$store.getters['nav/iosFullscreen']
      },
      hasFullScreenAction () {
        return (this.$store.state.actionsTray.actionsTray || [])
          .filter(item => item._compiled && item.name && item.name === 'file-viewer-fullscreen-action')
          .length > 0
      }
    },
    methods: {
      complete () {
        this.$store.dispatch('session/discardTour', this.$store.getters['session/userTours'][0] || '')
        this.$store.dispatch('dialog/showNextDialog')
      },
      getFallbackedTourSteps (current) {
        let index = this.tours.indexOf(this.$store.getters['session/userTours'][0])
        if (this.$store.getters['session/userTours'] && this.$store.getters['session/userTours'][0] && index > -1) {
          try {
            return require('~/components/common/tour/tours/' + (this.$machine.isDesktop ? 'desktop' : 'mobile') + '/' + current + '/' + this.tours[index] + '.js')
          } catch (e) {
            if (!current || current === languagesRoot) {
              return null
            }
            return this.getFallbackedTourSteps(supportedLanguages.get(current))
          }
        }
      },
      getObjectWithLangFallback (locale, object, transforFunction) {
        return getObjectWithLangFallback(locale, object, transforFunction)
      },
      getElemCoords (el) {
        let rect = el.getBoundingClientRect()
        let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop
        let elemHeight = el.clientHeight
        let elemWidth = el.clientWidth
        return {
          top: rect.top + scrollTop,
          bottom: rect.top + scrollTop + elemHeight,
          left: rect.left + scrollLeft,
          height: elemHeight,
          width: elemWidth
        }
      },
      goUp () {
        if (this.$store.state.nav.navPath.length > 0) {
          this.$router.push(this.$store.state.nav.navPath[this.$store.state.nav.navPath.length - 1].link)
        } else {
          this.$router.push(this.$store.state.nav.navRoot.link)
        }
      },
      loadScript (src) {
        return new Promise(resolve => {
          let scriptNode = document.createElement('script')
          scriptNode.type = 'text/javascript'
          scriptNode.src = src
          scriptNode.onload = event => {
            resolve(event)
          }
          document.body.appendChild(scriptNode)
        })
      },
      addScript (tag, text, location, id = '') {
        var s = document.createElement(tag)
        if (id) {
          s.setAttribute('id', id)
        }
        s.innerHTML = text
        document[location].appendChild(s)
      },
      tryToLoadCookieScripts () {
        if (this.cookiePermission.toString() === this.lastCookiesPermissionVersion.toString()) {
          this.tryToLoadAnalyticsConfig()
        }
      },
      tryToLoadAnalyticsConfig () {
        if (this.$config.gtmCode && this.$config.gtmCode.length > 0) {
          this.addScript('script', `window.dataLayer = window.dataLayer || []`, 'head', 'dataLayerInitialization')
          this.addScript('script', `(function(w,d,s,l,i){
            w[l]=w[l]||[];
            w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
            var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
            j.async=true;
            j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
            f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${this.$config.gtmCode}')`, 'head', 'tagManagerCode')
        } else if (this.$config.gaTrackingCode && this.$config.gaTrackingCode.length > 0 && !window.gtag) {
          this.loadScript('https://www.googletagmanager.com/gtag/js?id=' + this.$config.gaTrackingCode).then(() => {
            window.GA_TRACKING_ID = this.$config.gaTrackingCode
            window.dataLayer = window.dataLayer || []
            window.gtag = function () { window.dataLayer.push(arguments) }
            window.gtag('js', new Date())
            window.gtag('config', window.GA_TRACKING_ID, { send_page_view: false })
          }).catch(e => {
            console.error(e)
          })
        }
      },
      loadFixedWLHTML () {
        for (let i = 0; i < this.$whitelabel.htmlElements.length; i++) {
          let element = this.$whitelabel.htmlElements[i]
          const id = element.creationID

          if (element.script) this.loadScript(element.script)

          if (!element.content || (element.content.id !== 'head' && element.content.id !== 'body')) {
            continue
          }
          element = element.content
          const html = element.html.replace('>', ` id="${id}">`)
          const existingEl = document.getElementById(id)
          if (existingEl) existingEl.remove()
          document[element.id].insertAdjacentHTML(element.position, html)
        }
      },
      loadWLHTML () {
        for (let i = 0; i < this.$whitelabel.htmlElements.length; i++) {
          let element = this.$whitelabel.htmlElements[i]
          let id = element.creationID

          if (!element.content || element.content.id === 'head' || element.content.id === 'body') {
            continue
          }
          element = element.content

          const html = element.html.replace('>', ` id="${id}">`)
          const existingEl = document.getElementById(id)
          if (existingEl && element.position !== 'replace') existingEl.remove()

          let el = document.querySelector(element.id)
          if (el) {
            if (element.position === 'replace') {
              const wrapper = document.createElement('div')
              wrapper.innerHTML = html
              if (wrapper.firstChild) el.parentNode.replaceChild(wrapper.firstChild, el)
            } else {
              el.insertAdjacentHTML(element.position, html)
            }
          }
        }
      },
      skipUploadLimit (e) {
        e.stopPropagation()
        if (e.altKey && e.shiftKey && e.key.toLowerCase() === 'l') {
          if (this.sul !== '') {
            this.sul = ''
          } else {
            this.sul = 'UGVkaWN1bHVzIGh1bWFudXMgY29ycG9yaXMgZW4gZGFuw6lz'
          }
        }
      },
      checkFooterVisibility (e) {
        const footer = document.querySelector('.footer')
        const message = document.querySelector('.mobile-access-info')
  
        if (!footer || !message) return

        const footerRect = footer.getBoundingClientRect()
        const windowHeight = window.innerHeight

        const isVisible = footerRect.top < windowHeight && footerRect.bottom >= 0
        if (isVisible) {
          message.classList.add('footer-visible')
        } else {
          message.classList.remove('footer-visible')
        }
      }
    },
    created () {
      this.$store.dispatch('viewport/update')
      window.addEventListener('resize', event => {
        this.$store.dispatch('viewport/update')
      })

      // TODO review: why instant close of ActionTrayDrawer is only a problem in the viewer?
      document.addEventListener('mousedown', () => {
        if (this.actionsTrayDrawer) {
          if (this.hasFullScreenAction) {
            setTimeout(() => { this.actionsTrayDrawer = false }, 500)
          } else {
            this.actionsTrayDrawer = false
          }
        }
      })
      const scope = document.documentElement.style
      scope.setProperty('--primary', this.$vuetify.theme.primary)
      scope.setProperty('--primary_text', this.$vuetify.theme.primary_text)
      scope.setProperty('--primary_contrast', this.$vuetify.theme.primary_contrast)
      scope.setProperty('--secondary', this.$vuetify.theme.secondary)
      scope.setProperty('--accent', this.$vuetify.theme.accent)
      scope.setProperty('--error', this.$vuetify.theme.error)
      scope.setProperty('--info', this.$vuetify.theme.info)
      scope.setProperty('--warning', this.$vuetify.theme.warning)
      scope.setProperty('--success', this.$vuetify.theme.success)
      scope.setProperty('--ext_toolbar', this.$vuetify.theme.ext_toolbar)
      scope.setProperty('--gray', this.$vuetify.theme.gray)
      scope.setProperty('--background', this.$vuetify.theme.background)

      window.addEventListener('beforeunload', e => {
        const uploadingKeys = Object.keys($uploadState.filesByState[FILE_STATES.uploading])
        const pendingUploadKeys = Object.keys($uploadState.filesByState[FILE_STATES.pending])

        const downloadingKeys = Object.keys($downloadState.filesByState[FILE_STATES.downloading])
        const pendingDownloadKeys = Object.keys($downloadState.filesByState[FILE_STATES.pending])

        if (pendingUploadKeys.length > 0 || uploadingKeys.length > 0) {
          e.preventDefault()
          e.returnValue = ''
        }

        if (pendingDownloadKeys.length > 0 || downloadingKeys.length > 0) {
          e.preventDefault()
          e.returnValue = ''
        }
      })
      window.addEventListener('keydown', this.skipUploadLimit)
      MainBus.$on('analytics', (event) => {
        if (!window || !event || !event.action) {
          return
        }
        if (this.$config.gtmCode && Array.isArray(window.dataLayer)) {
          window.dataLayer.push({
            'event': event.action,
            ...event.arguments
          })
        } else if (window.gtag) {
          window.gtag('event', event.action, event.arguments)
        }
      })
      MainBus.$on('reloadWLhtml', () => this.loadWLHTML())
    },
    mounted () {
      window.addEventListener('offline', () => {
        this.$store.dispatch('session/setNetworkDiconnected', true)
      })
      window.addEventListener('online', () => {
        this.$store.dispatch('session/setNetworkDiconnected', false)
      })
      window.addEventListener('mousewheel', () => {})
      window.addEventListener('keydown', (event) => {
        if (event.key === 'n' && event.altKey === true) {
          this.$store.dispatch('notifications/addNotification', {
            avatar: 'notifications',
            title: 'Test Notification',
            header: 'Test Notification',
            body: Date.now() + ' Test Notification'
          })
        }
        if (event.keyCode === 27) {
          this.$store.dispatch('nav/fullScreen', false)
        }
      })
      document.body.addEventListener('scroll', this.checkFooterVisibility)
      document.body.addEventListener('resize', this.checkFooterVisibility)

      this.tryToLoadCookieScripts()
      console.info('Welcome to Idonia!')
      this.favicon.badge(this.newNotifications)

      if (!this.cookiePermission ||
        this.cookiePermission === true ||
        this.cookiePermission === 'true' ||
        parseInt(this.cookiePermission) < this.lastCookiesPermissionVersion) {
        this.$store.dispatch('dialog/showDialog', {
          title: this.$tf('cookie_notice.title'),
          body: require('~/components/common/dialog/types/DialogCookieNotice.vue').default,
          type: 'cookie',
          persistent: false,
          scrollable: true,
          width: 700,
          close: () => {},
          actions: {
            cancel: {
              title: this.$tf('Disagree'),
              callback: () => {
                this.$store.dispatch('session/setCookiePermission', false)
              }
            },
            accept: {
              title: this.$tf('Agree'),
              callback: () => {
                this.$store.dispatch('session/setCookiePermission', this.lastCookiesPermissionVersion)
              }
            }
          }
        })
      }

      MainBus.$on('expire-session', () => {
        if ((this.isAuthenticated || this.isPublicFile) && !this.expiringSession) {
          this.expiringSession = true
          this.$store.dispatch('dialog/unshiftDialog', {
            title: this.$tf('expire_session.title'),
            body: require('~/components/common/dialog/types/DialogExpireSession.vue').default,
            persistent: false,
            scrollable: false,
            width: 700
          })
        }
      })
      MainBus.$on('continue-session', () => {
        this.expiringSession = false
      })

      // Expiration dialog if page has been reload
      if (sessionStorage.getItem('expiration_logout')) {
        console.log(this.$tf('expire_session.logged_out.log', {count: this.$config.expireSessionTime}))
        this.$store.dispatch('dialog/showDialog', {
          title: this.$tf('expire_session.logged_out.title'),
          body: this.$tf('expire_session.logged_out.message'),
          persistent: false,
          width: 480,
          actions: {
            accept: {
              title: 'Close'
            }
          }
        })
      }
      sessionStorage.removeItem('expiration_logout')

      this.loadFixedWLHTML()
    },
    beforeDestroy () {
      document.body.removeEventListener('scroll', this.checkFooterVisibility)
      document.body.removeEventListener('resize', this.checkFooterVisibility)
    },
    updated () {
      this.loadWLHTML()
    },
    watch: {
      newNotifications: function (val) {
        this.favicon.badge(val)
      },
      smallViewport (val) {
        this.drawer = !val
      },
      cookiePermission () {
        this.tryToLoadCookieScripts()
      },
      tourSteps (val) {
        if (val !== null) {
          this.tourActive = true
        }
      },
      '$route' (to) {
        if (to.query['lang']) {
          setTimeout(() => {
            this.$store.dispatch('session/locale', to.query['lang'])
            this.$root.locale = to.query['lang']
          }, 500)
        }
      },
      sul (val) {
        MainBus.$emit('sul', val)
      }
    }
  }
</script>

<style lang="scss">

  .btn.primary, .toolbar.primary {
    color: var(--primary_contrast) !important;
  }

  .theme--dark.input-group--selection-controls label, .theme--dark.input-group:not(.input-group--error) label {
    color: var(--primary_contrast) !important;
  }

  .application {
    .primary--text, .primary--text.btn {
      color: var(--primary_text) !important;
    }
  }

  .toolbar.primary .btn:not(.accent):not(.secondary):not(.info):not(.success):not(.error):not(.warning):not(.primary--text):not(.theme--light) {
    color: var(--primary_contrast) !important;
  }

  a:not(.list a):not(.tabs a):not(.primary a) {
    color: var(--primary_text) !important;
  }
</style>

<style lang="stylus">
  @import '~vuetify/src/stylus/main';
  @import url('https://fonts.googleapis.com/icon?family=Material+Icons')
</style>

<style lang="scss">
  @import url('~cropperjs/dist/cropper.min.css');

  .application--wrap {
    min-height: var(--full-height) !important;
  }

    .material-icons {
  font-family: 'Material Icons';
  font-weight: normal;
  font-style: normal;
  font-size: 24px;  /* Preferred icon size */
  // display: inline-block;
  line-height: 1;
  text-transform: none;
  letter-spacing: normal;
  word-wrap: normal;
  white-space: nowrap;
  direction: ltr;

  /* Support for all WebKit browsers. */
  -webkit-font-smoothing: antialiased;
  /* Support for Safari and Chrome. */
  text-rendering: optimizeLegibility;

  /* Support for Firefox. */
  -moz-osx-font-smoothing: grayscale;

  /* Support for IE. */
  font-feature-settings: 'liga';
}

  * i {
    font-family: 'Material Icons';
  }

  .datatable tbody tr {
    border-left: 7px solid transparent;
  }

  .datatable tbody tr:hover {
    border-left: 7px solid var(--primary);
  }

  .logo {
    background-color: var(--primary)
  }

  .tabs__container > li > a.tabs__item.tabs__item--active {
    color: var(--accent)
  }

  .alert {
    border-width: 4px !important;
    border-radius: 5px !important;
    opacity: 0.95 !important;
  }

  .text-t {
    &-lower {
      text-transform: lowercase !important;
    }
    &-upper {
      text-transform: uppercase !important;
    }
    &-capitalize {
      text-transform: capitalize !important;
    }
    &-title {
      text-transform: lowercase !important;
      font-size: 2rem;
      &:first-letter {
        text-transform: uppercase !important;
        font-size: 2rem;
      }
    }
    &-none {
      text-transform: none !important;
    }
  }

  html {
    overflow: hidden !important;
    max-height:  var(--full-height) !important;
    height: var(--full-height) !important;
    body {
      overflow-y: auto !important;
      overflow-x: hidden !important;
      max-height: var(--full-height) !important;
      height: var(--full-height) !important;
    }
  }

  aside {
    transition: none !important;
  }

  .tooltip__content {
    z-index: 1500 !important;
  }

  #app {
    // .material-icons {
    //   text-rendering: optimizeLegibility !important;
    //   user-select: none !important;
    // }
  }

  .ie {
    .no-more-results {
      align-self: center;
    }

    .chip {
      display: inline-block;
      padding: 0 8px;
      line-height: 2rem;
    }

    .image-viewer {
      display: block;
      img {
        display: block;
        width: auto;
        height: auto;
        margin: auto;
      }
    }
  }

  .card .container {
    max-width: none;
  }

  .full-height {
    display: flex;
    flex: 1;
    flex-direction: column;
  }

  .fixed-pos {
    margin-top: 150px;
  }

  .full-width {
    min-width: 100%;
  }

  #app {
    min-height: 100%;
    margin: 0 !important;
    background-color: var(--background) !important;
  }

  #app.stuck {
    overflow: hidden;
  }

  .toolbar.info-tabs {
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
  }

  .toolbar.theme--dark .input-group--focused .icon {
    color: #ffffff !important;
  }

  .toolbar .input-group__messages {
    display: none !important;
  }

  .toolbar .input-group__details {
    min-height: 2px !important;
    height: 2px !important;
  }

  .toolbar.theme--dark .input-group__details:after {
    background-color: #ffffff !important;
  }

  // .progress-linear {
  //   margin: 0;
  //   visibility: hidden;
  // }

  .progress-linear.loading {
    visibility: visible;
  }

  .dialog__content {
    z-index: 600 !important;
  }

  .info-pill {
    color: #37352F;
    background-color: #FBEECC;
    padding: .5rem;
    font-size: 14px;
    align-items: flex-start;
    border-radius: 8px;
    .icon {
      margin-left: .25rem;
      margin-right: .25rem;
    }
  }
  .success-pill {
    color: #2F3731;
    background-color: #9CF2BD;
    padding: .5rem;
    font-size: 14px;
    display: inline-block;
    border-radius: 8px;
    .icon {
      margin-left: .25rem;
      margin-right: .25rem;
    }
  }
  .error-pill {
    color: #372F2F;
    background-color: #FFD8D8;
    padding: .5rem;
    font-size: 14px;
    display: inline-block;
    border-radius: 8px;
    .icon {
      margin-left: .25rem;
      margin-right: .25rem;
    }
  }

  @media only screen and (max-width: 1023px) {
    .dialog__content {
      top: 64px !important;
      height: calc(var(--full-height) - 60px) !important;
    }
    .router-container {
      padding: 0 !important;
    }

    .fixed-pos {
      margin-top: 85px;
    }
  }

  [data-quick-access] {
    position: relative !important;
  }

  [data-quick-access][data-quick-access-type=before]:before,
  [data-quick-access][data-quick-access-type=after]:after {
    content: attr(data-quick-access);
    position: absolute;
    background-color: white;
    box-shadow: 0 1px 5px rgba(0, 0, 0, .2), 0 2px 2px rgba(0, 0, 0, .14), 0 3px 1px -2px rgba(0, 0, 0, .12);
    width: 20px;
    height: 20px;
    border: 1px solid black;
    border-radius: 2px;
    text-align: center;
    right: 20px;
    bottom: -8px;
    z-index: 99;
  }

  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  ::-webkit-scrollbar-track {
    background: #ddd;
  }

  ::-webkit-scrollbar-thumb {
    background: #666;
  }

  [draggable=true] {
    -khtml-user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;

    -khtml-user-drag: element;
    -moz-user-drag: element;
    -webkit-user-drag: element;
    user-drag: element;
  }

  .menu__content {
    z-index: 1100 !important;
  }
  .headers{
    z-index: 5;
  }
  #router-view {
    background-color: transparent;
    max-width: 100%;
  }

  .btn--floating.btn--small {
    height: 50px;
    width: 50px;
  }

  @media only screen and (max-width: 599px) {
    .menu-xs-responsive {
      max-height: 45vh !important;
      height: auto !important;
      overflow-y: scroll !important;
    }

    .color-filter-grid {
      display: grid !important;
      grid-template-columns: repeat(auto-fill, 50px) !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue